"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _Addons = require("../../../../../../Addons"),
    _AddonsInvoice = _interopRequireDefault(require("../components/AddonsInvoice"));

function AddonsInvoice(props) {
  return _react["default"].createElement(_Addons.AddonsConsumer, null, function (_ref) {
    var _ref$actions = _ref.actions,
        getCaptions = _ref$actions.getCaptions,
        getAddonsCost = _ref$actions.getAddonsCost,
        getCurrencySymbol = _ref$actions.getCurrencySymbol,
        getFormattedAddon = _ref$actions.getFormattedAddon;
    return _react["default"].createElement(_AddonsInvoice["default"], (0, _extends2["default"])({
      getCaptions: getCaptions,
      getAddonsCost: getAddonsCost,
      getCurrencySymbol: getCurrencySymbol,
      getFormattedAddon: getFormattedAddon
    }, props));
  });
}

var _default = AddonsInvoice;
exports["default"] = _default;